/**
 * A recusa da conclusão por identificação incompleta (E177.F1.C03, GUS-253 item 3): só os campos
 * que o servidor diz que faltam, para a mensagem não pedir de novo o que a pessoa já preencheu.
 */
export const ptBRFaltasDaIdentificacao = {
  mensagem: 'Falta identificação: volte e preencha {campos}.',
  campos: {
    process_number: 'o número do processo',
    pasta: 'a pasta do banco',
    cpf_informado: 'o CPF do cliente',
  },
  eFinal: ' e ',
} as const;
